<template>
  <div>
    <card title="Acompanhamento de Denúncia">
      <template slot="content">
        <div v-if="!isErroGetDados">
          <div class="row">
            <div class="col-md-6">
              <h4>Denúncia: {{ denuncia.protocolo }}</h4>
            </div>
            <div class="col-md-6 alinhamento-direita">
              <h4 v-if="denuncia.tipo_id"> Classificação: {{this.denuncia.tipo.tipo}}</h4>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <b-progress height="20px" :max="100">
                <b-progress-bar v-bind:style="[cBackgroundColor, {fontSize: '16px',fontWeight: '700'}]" :value="cValue" :label="cLabel">
                </b-progress-bar>
              </b-progress>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h5>Informações</h5>
              <hr>
            </div>
          </div>

          <div class="container row align-items-center justify-content-center">
            <div class="col text-justify text-break">
              <h6>Data de Abertura: <span class="texto-informacoes">{{ retornarData(denuncia.created_at) }}</span></h6>
              <h6>Criado por: <span class="texto-informacoes">{{ cCriadoPor }}</span></h6>
              <h6>Telefone: <span class="texto-informacoes">{{ cPhone }}</span></h6>
              <h6>Email: <span class="texto-informacoes">{{ cEmail }}</span></h6>
              <h6>Relação: <span class="texto-informacoes">{{ cRelacao }}</span></h6>
              <h6>Descrição: <span class="texto-informacoes">{{ denuncia.descricao }}</span></h6>
            </div>
            <template v-if="cAnexo">
              <div class="col-1">
                <h6>Anexos:</h6>
              </div>
              <div class="col-5">
                <h6 v-for="item in denuncia.arquivos" :key="item.local">
                  <a @click="downloadArquivo(item)">{{ item.nome }}</a>
                </h6>
              </div>
            </template>
          </div>
        </div>
        <div v-else>
          <div class="container alinhar-centro container-campo-central ">
            <h4>Ocorreu um erro, tente novamente!</h4>
          </div>
        </div>
      </template>
    </card>

    <div class="container content-box" v-if="!isErroGetDados">
      <h5>Respostas</h5>
      <div v-if="denuncia.historicos != '' ">
        <div v-for="item in cHistorico" v-bind:key="item.id" class="row">
          <div class="col-md-12 espacamento">
            <hr>
            <div class="row espacamento">
              <div class="col-md-4">
                <h6>Equipe de Compliance</h6>
              </div>
              <div class="col-md-4 resposta-data-alinhamento">
                <h6 class="cor-data-card"> {{ retornarData(item.created_at) }}</h6>
              </div>
              <div class="col-md-4 resposta-status-alinhamento">
                <h6>{{ item.status.status }}</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-justify">
                <p>{{ item.descricao }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-12">
            <p>A denúncia não contém nenhuma resposta.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  p {
    font-weight: 300;
  }

  h3, h4, h5, h6 {
    color: #142260;
    font-weight: 700;
  }

  hr {
    margin: 0px;
    padding-bottom: 5px;
  }

  .texto-informacoes {
    color: #494949;
    font-weight: 300;
  }

  .resposta-status-alinhamento {
    text-align: right;
  }

  .resposta-data-alinhamento {
    text-align: center;
  }

  .alinhamento-direita {
    text-align: right;
  }

  @media (max-width: 425px)  {
    .resposta-data-alinhamento {
      text-align: left;
    }
    .resposta-status-alinhamento {
      text-align: left;
    }
  }
</style>

<script>
import MetaModal from 'meta-modal'
import Card from './templates/Card.vue'
import Utils from '@/mixins/utils.js'

export default {
  name: 'Acompanhamento',

  components: {
    MetaModal,
    Card,
  },

  mixins: [
    Utils,
  ],

  data () {
    return {
      isErroGetDados: false,
      status: [],
      denuncia: {},
      denunciaToken: this.$route.params.token,
    }
  },

  computed: {
    // Função que calcula o tamanho do progresso da barra
    cValue() {
      let progressoBarra = 100/this.status.length;

      if (this.denuncia.historicos && this.denuncia.historicos.length > 0) {
        progressoBarra = progressoBarra * this.denuncia.historicos[this.key].status_id;

        return progressoBarra;
      }

      return progressoBarra;
    },

    // Função que retorna a cor da barra de progresso.
    // Ela tem retorno verde se o status não for concluído,
    // caso contrário retorna azul
    cBackgroundColor() {
      let background = '#97CA40';

      if (this.denuncia.historicos && this.denuncia.historicos.length > 0 && this.denuncia.historicos[this.key].status_id == this.status.length) {
        background = '#2855A6';
      }

      return {backgroundColor: background};
    },

    // Função que retorna o status atual da denúncia
    cLabel() {
      if (!this.denuncia.historicos || !this.denuncia.historicos.length) {
        return 'Aberto';
      }

      return this.denuncia.historicos[this.key].status.status;
    },

    // Função que retorna a relação de quem efetuou a denúncia,
    // caso este não possua, retorna "Não informado"
    cRelacao() {
      if (this.denuncia.relacao_id == null) {
        return 'Não informado';
      }

      return this.denuncia.relacao.relacao;
    },

    // Função que retorna o nome de quem efetuou a denúncia,
    // caso este não possua, retorna "Anônimo"
    cCriadoPor() {
      if (this.denuncia.criado_por == null) {
        return 'Anônimo';
      }

      return this.denuncia.criado_por;
    },

    cHistorico() {
      if (!this.denuncia.historicos) {
        return {};
      }

      return this.denuncia.historicos;
    },

    cPhone() {
      if(!this.denuncia.phone) {
        return 'Não Informado';
      }

      return this.denuncia.phone;
    },

    cEmail() {
      if(!this.denuncia.email) {
        return 'Não Informado';
      }

      return this.denuncia.email;
    },

    key() {
      if (this.denuncia.historicos) {
        return this.denuncia.historicos.length - 1;
      }

      return 0;
    },

    cAnexo() {
      if (!this.denuncia.arquivos) {
        return false;
      }

      if (this.denuncia.arquivos.length == 0) {
        return false;
      }

      return true;
    },
  },

  created() {
    this.statusDenuncia();
    this.protocoloDenunciaInvalido();
  },

  methods: {
    exibirModalErro() {
      if (this.isErroGetDados) {
        swal({
          title: 'Ocorreu um erro!',
          text: 'Este número de protocolo não existe.',
          icon: 'error',
        }).then(this.encaminhaAcompanhamento);
      }
    },

    encaminhaAcompanhamento() {
      this.$router.push({path: '/consulta-denuncia'});
    },

    retornarData(data) {
      const moment = this.$moment(data);

      return moment.format('DD/MM/YYYY - HH:mm');
    },

    async statusDenuncia() {
      try {
        this.$parent.loading = true;
        const { data: response } = await this.$http.get('/status');
        this.status = response;
      } catch (e) {
        this.isErroGetDados = true;
        this.exibirModalErro();
      } finally {
        this.$parent.loading = false;
      }
    },

    async protocoloDenunciaInvalido () {
      try {
        this.$parent.loading = true;
        const { data: response } =  await this.$http.get(`/denuncias/${this.denunciaToken}`);
          if (!response) {
            this.isErroGetDados = true;
            this.exibirModalErro();
            return;
          }
          this.denuncia = response;
      } catch (e) {
        this.isErroGetDados = true;
        this.exibirModalErro();
      } finally {
        this.$parent.loading = false;
      }
    },

    async downloadArquivo(arquivo) {
      try {
        this.$parent.loading = true;
        const { data: response } =  await this.$http.get(`/verifica-arquivo/${arquivo.id}`);
        if(!response.success) {
          this.$parent.loading = false;
          this.customAlert(
            'Erro!',
            'Erro ao efetuar o download do arquivo.',
            'error',
          );
          return;
        }
        window.open(`${this.$root.url}/arquivo-download/${arquivo.id}?Key=${this.$root.chaveFront}`);
      } catch (e) {
        this.isErroGetDados = true;
        this.exibirModalErro();
      } finally {
        this.$parent.loading = false;
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Acompanhamento.vue